import posthog from "posthog-js";

// Defer the ~140 KB PostHog runtime until the browser is idle so it never
// competes with hydration and the hero intro. The first pageview is still
// captured by init(); the idle timeout caps the delay at 2 s.
function initPostHog() {
	posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
		api_host: "/ingest",
		ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
		// Include the defaults option as required by PostHog
		defaults: "2025-11-30",
		// Capture individual clicks, inputs, and form submits automatically
		autocapture: true,
		// Track pageviews across App Router client-side navigations, plus exits
		capture_pageview: "history_change",
		capture_pageleave: true,
		// Performance: Core Web Vitals + resource/network timing
		capture_performance: {
			web_vitals: true,
			network_timing: true,
		},
		// Heatmap data (rageclicks, dead clicks, scroll depth)
		enable_heatmaps: true,
		// Enables capturing unhandled exceptions via Error Tracking
		capture_exceptions: true,
		// Turn on debug in development mode
		debug: process.env.NODE_ENV === "development",
	});
}

if (typeof window !== "undefined") {
	if (typeof window.requestIdleCallback === "function") {
		window.requestIdleCallback(initPostHog, { timeout: 2000 });
	} else {
		window.setTimeout(initPostHog, 500);
	}
}

// IMPORTANT: Never combine this approach with other client-side PostHog initialization approaches,
// especially components like a PostHogProvider. instrumentation-client.ts is the correct solution
// for initializing client-side PostHog in Next.js 15.3+ apps.
